module.exports = {
  __depends__: [ require(335) ],
  __init__: [ 'touchInteractionEvents' ],
  touchInteractionEvents: [ 'type', require(411) ],
  touchFix: [ 'type', require(410) ]
};